import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import PropTypes from 'prop-types';

import { VFText, Icon, CheckBox } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { Images } from '../../../Themes';
import SohoFrameworkTestKeys from '../../../Utils/SohoFrameworkTestKeys';

import styles from './SelectionItem.Styles';

function SelectionItem({
  title,
  subTitle,
  subTitlePlaceholders,
  icon,
  withRemove,
  withSelect,
  isSelected,
  onSelectPress,
  onRemovePress,
  removeButtonTitle,
  removeTestKey,
  selectTestKey,
  titleTestKey,
  ...props
}) {
  const theme = useTheme();

  return (
    <>
      <View style={styles.containerStyle}>
        <Icon name={icon} size={24} />
        <View style={styles.infoContainerStyle}>
          <VFText
            testKey={titleTestKey || SohoFrameworkTestKeys.PlanUserNameTitle}
            i18nKey={title}
            type="primary"
            style={styles.nameTextStyle}
          />
          {subTitle ? (
            <VFText
              i18nKey={subTitle}
              placeHolders={subTitlePlaceholders}
              style={styles.subtitleTextStyle}
            />
          ) : null}
        </View>

        {withRemove ? (
          <TouchableOpacity style={styles.removeContainerStyle} onPress={onRemovePress}>
            <VFText
              i18nKey={removeButtonTitle}
              type="textWithIcon"
              style={styles.removeTextStyle}
              accessibilityLabel={removeTestKey}
            />
            <Icon name={Images.ic_Delete_Red} size={16} />
          </TouchableOpacity>
        ) : null}

        {withSelect ? (
          <CheckBox
            testID={selectTestKey}
            value={isSelected}
            onValueChange={onSelectPress}
            style={styles.checkBoxStyle}
          />
        ) : null}
      </View>
      <View style={styles.dividerStyle(theme)} />
    </>
  );
}

SelectionItem.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  subTitlePlaceholders: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.shape({ uri: PropTypes.string }),
  withRemove: PropTypes.bool,
  withSelect: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelectPress: PropTypes.func,
  onRemovePress: PropTypes.func,
  removeButtonTitle: PropTypes.string,
  removeTestKey: PropTypes.string,
  selectTestKey: PropTypes.string,
  titleTestKey: PropTypes.string,
};

export default SelectionItem;
